import { getBaseDomain } from '../utils/helpers';

// lib/firebase-admin.js
export default async function getServerSideRemoteConfig(hostname) {
  // Only run on server-side
  if (typeof window !== 'undefined') {
    return null;
  }
  try {
    // Use eval to completely hide imports from bundler
    const firebaseAdmin = eval('require("firebase-admin/app")');
    const firebaseRemoteConfig = eval('require("firebase-admin/remote-config")');
    const { initializeApp, getApps, cert } = firebaseAdmin;
    const { getRemoteConfig } = firebaseRemoteConfig;

    const baseDomain = getBaseDomain(hostname);
    let base64Key;
    let appName;

    if (baseDomain === 'nextias') {
      base64Key = process.env.NEXTIAS_FIREBASE_SERVICE_ACCOUNT_BASE64;
      appName = 'nextias-admin';
      // console.log('ssr firebase nextias', base64Key);
      if (!base64Key) {
        console.warn('[SSR] No Firebase service account key found in environment variables. nextias');
        return null;
      }
    } else {
      base64Key = process.env.MADEEASY_PRIME_FIREBASE_SERVICE_ACCOUNT_BASE64;
      appName = 'madeeasy-admin';
      // console.log('ssr firebase madeeasy', base64Key);
      if (!base64Key) {
        console.warn('[SSR] No Firebase service account key found in environment variables. madeeasy');
        return null;
      }
    }

    function getAdminApp() {
      // Check if app with this name already exists
      const existingApp = getApps().find((app) => app.name === appName);
      if (existingApp) {
        return existingApp;
      }

      // Initialize new app with unique name
      const serviceAccount = JSON.parse(
        Buffer.from(
          base64Key,
          'base64',
        ).toString('utf8'),
      );
      return initializeApp({
        credential: cert(serviceAccount),
      }, appName);
    }

    const app = getAdminApp();
    const remoteConfig = getRemoteConfig(app);
    const template = await remoteConfig.getTemplate();
    const configValues = {};

    // Parse each config value
    for (const [key, param] of Object.entries(template.parameters)) {
      const rawValue = param.defaultValue?.value || null;

      if (rawValue === null) {
        configValues[key] = null;
        continue;
      }

      // Try to parse as JSON first (for objects, arrays, numbers)
      if (typeof rawValue === 'string') {
        try {
          configValues[key] = JSON.parse(rawValue);
        } catch {
          // If not JSON, check for boolean strings
          if (rawValue === 'true') {
            configValues[key] = true;
          } else if (rawValue === 'false') {
            configValues[key] = false;
          } else {
            // Keep as string
            configValues[key] = rawValue;
          }
        }
      } else {
        // Already a primitive type (number, boolean, etc.)
        configValues[key] = rawValue;
      }
    }

    return configValues;
  } catch (error) {
    console.error('[SSR] Error fetching Remote Config:', error);
    return null;
  }
}
